import AREACODE from './lang_areacode'
import lang_hk from './ZH_HK'

const enterpriseModule = {
	'en': {
		'enterprise': {
			'no-data': 'No Data',
			'no-module-data': 'No Module Data',
			'no-report-data': 'No Report Data',
			'no-event-data': 'No Data',
			'irstore': '{name} IR',
			'submit': 'Submit',
			'cancel': 'Cancel',
			'time': 'Time',
			'loading': 'Loading...',
			'effort-loading': 'Loading...',

			'report-tips-in-hk09606': '*The relevant content in these reports is automatically captured and generated by a third-party information platform. The institutions and analysts mentioned in the reports are not commissioned by Duality Biotherapeutics (hereinafter referred to as the "Company") to state opinions. Any views, estimates, or forecasts presented are solely the independent judgments of the individuals or their respective institutions and do not represent the position, estimates, or forecasts of the Company or its management. The mention of the Company in such content or the circulation of related content does not constitute endorsement or agreement with the information, conclusions, or recommendations regarding the Company.',

			'industry': '',
			// 留言成功提示
			'message-sent-success': 'Successfully, thank you for your attention and suggestions!',
			'error': 'Error',

			'common-a': {
				'updated': 'Updated',
			},
			'common-b': {
				'updated': 'Updated',
			},

			// 其他
			'see-more': 'More',
			'view-details': 'View details',
			'previes': 'Previes',

			'currency-unit': '',
			'unchanged': '0.00',
			'all': 'All',
			'more': 'More',

			// 股票行情
			'high': 'High',
			'low': 'Low',
			'P/E': 'P/E(TTM)',
			'P/B': 'P/B',
			'turnover': 'Turnover',
			'volume': 'Volume',
			'market-cap': 'Mkt Cap',
			'float-cap': 'Flo Cap',
			'loss': 'Loss',
			'market-quotes': 'Market Quotes',
			'year': '', // 展示空
			'day': 'Day',
			'week': 'Week',
			'month': 'Month',
			'candle': 'Candle',
			'UTC': 'UTC+8',
			'div-yied': 'Div Yied(TTM)',

			// 分红配送
			'announced': 'Announced',
			'ex-date': 'Ex-Date',
			'record-date': 'Record Date',
			'payment-date': 'Payment Date',
			'dividend-scheme': 'Dividend Scheme (Per 10 shares)',
			'bonus-issue/by-reserve': 'Bonus Issue/by Reserve (Per 10 shares)',
			'dividends': 'Dividends',
			'disclaimer': 'Power by Comein. No content herein shall be considered an offer, solicitation or recommendation for the purchase or sale of securities or other investment products.',

			// 投关活动
			'investment': {
				// --------路演状态
				'preview': 'Preview',
				'live': 'Live',
				'playback': 'Playback',
				'ended': 'Ended',
				// --------路演权限
				'audition': 'Audition',
				'plubic': 'Plubic',
				'pay': 'Pay',
				'special': 'Special',
				'private': 'Private',
				'apply': 'Apply',
				'member': 'Member',
				'institution': 'Institution',
				'views': 'views',
				'summary': 'Summary',

				'roadshow': 'roadshow',
				'activity': 'activity',
			},
			'IR-events': 'IR-Events',


			// 新闻资讯
			'news': 'News',
			'no-news-data': 'No Data',
			'news-detail': 'News Detail',
			'report-detail': 'Report Detail',
			'data-time': 'Data Time',
			'news-updated': 'Updated',
			'news-resource': 'Resource',
			'copy-success': 'Success',
			'copy-error': 'Error',

			// 互动问答
			'QA': {
				'search': 'Search',
				'tab': {
					'meeting': 'Meeting',
					'enquiry': 'Enquiry',
					'activities': 'Activities',
				},
				'question': 'Q&A',
				'Q&A': 'Q&A' // 英文不展示
			},
			// 翻译为英文时，无需展示「回答于」和问答来源
			'from-leave-message': 'From Leave Message',
			'answer-to-message': '',
			'disclose-to-message': '',

			// 季度业绩
			//--------- 业绩期
			'results': {
				'annual': 'Annual',
				'interim': 'Interim',
				'first-quarter': 'First',
				'third-quarter': 'Third',
				'fourth-quarter': 'Fourth',
			},

			'annual': 'Annual',
			'interim': 'Interim',
			'first-quarter': 'First Quarter',
			'third-quarter': 'Third Quarter',
			'fourth-quarter': 'Fourth Quarter',

			//--------- - 内容标题
			'quarter-title': {
				'financial-indicators': 'Financial Indicators',  // 季度业绩-内容标题-财务数据
			},
			'results-announcement': 'Announcement',
			'results-summary': 'Summary',
			'earnings-calls': 'Calls',
			'earnings-presentation': 'Presentation',
			'business-review-and-outlook': 'BUSINESS REVIEW AND OUTLOOK',
			'page-version': 'Page Version',
			'earnings-library': 'Earnings Library',
			'earnings-library--btn': 'Quarterly Report',

			'quarter': {
				'financial-indicators': 'Financial Indicators', //  季度业绩-财务指标
			},


			// 主要财务指标
			'finance-data': {
				'first-quarter': 'First',
				'interim': 'Interim',
				'third-quarter': 'Third',
				'fourth-quarter': 'Fourth',
				'annual': 'Annual',
			},
			// --  数据指标-每股指标
			'BVPS': 'BVPS',
			'CFPS': 'CFPS',
			'EPS': 'EPS',
			'CapSurFdPS': 'CapSurFdPS',
			'UPS': 'UPS',
			'operating-income-per-share': 'Operating Income Per Share',

			// --  数据指标-偿还能力指标
			'current-ratio': 'Current Ratio',
			'quick-ratio': 'Quick Ratio',
			'current-debt-ration': 'Current Debt Ration',
			// --  数据指标-营运能力指标
			'accounts-receivable-turnover': 'Accounts Receivable Turnover',
			'inventory-turnover-ratio': 'Inventory Turnover Ratio',
			'current-assets-turnover': 'Current Assets Turnover',
			'FATR': 'FATR',
			'ATR': 'ATR',
			// --  数据指标-盈利能力指标
			'gross-margin': 'Gross Margin',
			'NPM': 'NPM',
			'ROE': 'ROE',
			'ROA': 'ROA',
			'main-indicators': {
				'financial-indicators': 'Financial Indicators',  // 主要财务指标-主要指标
			},
			'revenue-growth-rate': 'Revenue Growth Rate',
			'operating-profit-grow-rate': 'Operating Profit Grow Rate',
			'net-profit-growth-rate': 'Net Profit Growth Rate',
			'total-assets-growth-rate': 'Total Assets Growth Rate',
			'CFPS': 'CFPS',

			'YoY': 'YoY',
			'QoQ': 'QoQ',

			// 利润表
			// 利润表 - 数据指标
			'total-operating-revenue': 'Operating Revenue',
			'total-operating-cost': 'Total Operating Cost',
			'operating-profit': 'Operating Profit',
			'total-profit': 'Total Profit',
			'net-profit': 'Net Profit',
			'net-profit-of-parent-company-owners': 'CNIS',
			'profit': 'profit',

			'income-statement': 'Income Statement',

			// 资产负债表
			// 资产负债表 - 数据指标 - 总资产
			'total-assets': 'Total Assets',
			'current-assets': 'Current Assets',
			'non-current-assets': 'Non-Current Assets',
			'money-capital': 'Money Capital',
			'long-term-loans': 'Long-term Loans',
			'owners-equity': "Owner's Equity",
			// 资产负债表 - 数据指标 - 总负债
			'total-liabilitise': 'Total Liabilitise',
			'current-liabilitise': 'Current Liabilitise',
			'non-current-liabilitise': 'Non-Current Liabilitise',
			// 资产负债表 - 数据指标 - 股东权益
			'shareholders-equity': 'Shareholders equity',
			'paid-in-capital': 'Paid-in capital',
			'retained-profit': 'Retained profit',
			'additional-paid-in-Capital': 'Additional Paid-In Capital',
			'legal-reserve': 'Legal Reserve',

			'balance-sheet': 'Balance Sheet',

			// 现金流量表
			// 现金流量表 - 数据指标
			'operating-cash-flow': 'Operating Cash',
			'investing-cash-flow': 'Investing Cash',
			'finaning-cash-flow': 'Finaning Cash',
			'cash-flow': 'Cash Flow',

			// 券商研报
			'research-report-list': 'Research Report List',
			'research-report': 'Rating',

			'rating': 'Rating',
			// 券商研报 - 评级
			'buy': 'Buy',
			'hold': 'Hold',
			'sell': 'Sell',
			'non': 'No Rating',

			// 公司公告
			'announcement': {
				'all': 'All',
			},
			'announcement': 'Announcement',
			'regular-announcement': 'Regular Announcement',
			'interim-announcement': 'Interim Announcement',

			// 股东结构
			'number-of-shareholders': 'Number',
			'thousand-households': 'Thousand households',
			'percentage-of-change': 'Percentage of change',
			'average-holding': 'Average holding',

			'institutional-holding': '',  // 英文机构持股暂不展示
			'top-10-holders': 'TOP 10',
			'top-10-float-holders': 'TOP 10 Float',
			'shareholder': 'Shareholder',

			'shareholder-institution': '持股机构',
			'number-of-shares-held': 'Shares Held',
			'proportion-of-total-share-capital': 'Ratio Shares',
			'percentage-of-total-circulating-share-capital': 'Ratio Share (float)',
			'QoQ-change': 'QoQ',

			// 北上资金
			'holding-date': 'Date',
			'closing-price': 'Close',
			'daily-change': '%Chg',
			'number-of-shares-held-(shares)': 'Shares Held',
			'holding-percentage': 'Ratio Shares',

			// 融资融卷 - 英文版本做了限制
			'trading-day': '交易日期',
			'current-financing-balance': '本日融资余额(元)',
			'current-financing-purchase-amount': '本日融资买入额(元)',
			'current-short-selling-balance': '本日融券余量(股)',
			'current-short-selling-volume': '本日融券卖出量(股)',
			'short-selling-balance-amount': '融券余量金额(元)',
			'securities-lending-balance': '融资融券余额(元)',


			// 公募持仓
			'fund-name': 'Fund Name',
			'percentage-of-circulating-shares': 'Ratio Share (float)',

			// 预约调研
			'scheduled-research': 'Survey',

			// 投关日历
			'today': 'Today',
			'No-events-on-the-selected-date': 'No Data',
			'financial-calendar': 'Financial Calendar',

			// ESG
			'esg-rating': 'ESG Rating',
			'esg-report': 'ESG Report',

			'monday': 'M',
			'tuesday': 'T',
			'wednesday': 'W',
			'thursday': 'T',
			'friday': 'F',
			'saturday': 'S',
			'sunday': 'S',


			// 企业管治
			'company-structure': 'Company Structure',
			'structure-report': 'Structure Report',

			// 标准表单
			'normal-field': {
				'name': 'Name',
				'company': 'Company',
				'position': 'Position',
				'phone': 'Phone',
				'email': 'Email',
				'success-email': 'Please enter a valid email',
				'verification': 'Verification',
				'send-code': 'Send code',

				'tips': 'Please enter your {label}',
				'valid-tips': '{label} is a required field',

				'subscribe-success': 'Subscription Successful',
				'code-sent-to-email': 'Verification code has been sent to email',

				'msg-box': {
					'10015': 'Your contact information already exists, please do not subscribe repeatedly',
					'10016': 'You are already subscribed',
					'10017': 'Your email/contact information already exists, please do not subscribe repeatedly',
					'10018': 'Verification code sent too frequently. Please wait and try again',
					'10019': 'Verification code error',
					'10020': 'Invalid phone number',
					'10021': 'Incorrect email format'
				},
				'eventName': 'Category',
				'eventName-tips': 'Please select the Category',
			},
			'subscription-terms': 'Subscription Terms',
			'subscribe': 'subscribe',

			'field': {
				'tips': '{label} is  a required field',
				'custom-tips': '{label} is  a required field',
				'success-email': 'Please enter a valid email',
			},

			'leave-word': {
				'submitted-tip': 'Submitted successfully',
				'result-tip': 'Dear investors, your message has been submitted to Chen, we will listen to your feedback. The voice of investors is our driving force forward, your participation will inject new vitality for the development of the company, thank you for your participation!'
			},
			'Busy': 'Busy',

			'message-subscription': {
				'content': 'Keep up to date with the latest company news and announcements and stay in touch with us'
			}
		}
	},
	'zh-cn': {
		'enterprise': {
			'no-data': '暂无数据',
			'no-module-data': '暂无模块数据',
			'no-report-data': '研报找不到了～',
			'no-event-data': '活动找不到了～',
			'irstore': '{name}投资者关系',
			'submit': '提交',
			'cancel': '取消',
			'time': '时间',
			'loading': '加载中...',
			'effort-loading': '正在努力加载',

			'report-tips-in-hk09606': '*报告相关内容由第三方信息平台自动抓取生成。报告中所提及的机构及分析师均非受映恩生物-B（以下简称“公司”）委托发表意见。其所提出的任何观点、估算或预测，仅代表其个人或所在机构的独立判断，均不代表公司及其管理层的立场、估计或预测。公司在此类内容中的被提及或对相关内容进行传阅，并不构成对公司信息、结论或建议的认可或同意。',

			'industry': '所属行业：',
			// 留言成功提示
			'message-sent-success': '提交成功，感谢您的关注和建议！',
			'error': '服务器错误, 请重试',

			'common-a': {
				'updated': '截止时间',
			},
			'common-b': {
				'updated': '数据更新',
			},

			// 其他
			'see-more': '查看更多',
			'view-details': '查看详情',
			'previes': '预览',
			'currency-unit': '货币单位：',
			'unchanged': '不变',
			'all': '全部',
			'more': '更多',

			// 股票行情
			'high': '最高',
			'low': '最低',
			'P/E': '市盈率(TTM)',
			'P/B': '市净率',
			'turnover': '成交额',
			'volume': '成交量',
			'market-cap': '总市值',
			'float-cap': '流通值',
			'loss': '亏损',
			'market-quotes': '股票行情',
			'year': '年',
			'day': '日',
			'week': '周',
			'month': '月',
			'candle': 'K线',
			'UTC': '北京时间',
			'ten-thousand': '万',
			'one-hundred-million': '亿',
			'one-trillion': '万亿',
			'div-yied': '股息率(TTM)',


			// 分红配送
			'announced': '公告日',
			'ex-date': '除尽日',
			'record-date': '登记日',
			'payment-date': '派息日',
			'dividend-scheme': '分红(每10股税前)',
			'bonus-issue/by-reserve': '送股/转增(每10股)',
			'dividends': '分红送配',
			'disclaimer': '进门提供技术支持，仅供交流参考使用，不构成任何投资建议',

			// 投关活动
			'investment': {
				// --------路演状态
				'preview': '预告',
				'live': '直播',
				'playback': '回放',
				'ended': '已结束',
				// --------路演权限
				'audition': '试听',
				'plubic': '公开',
				'pay': '付费',
				'special': '专场',
				'private': '私密',
				'apply': '报名',
				'member': '会员',
				'institution': '机构通',
				'views': '次浏览',
				'summary': '调研纪要',
				'roadshow': '路演会议',
				'activity': '调研活动',
			},
			'IR-events': '投关活动',


			// 新闻资讯
			'news': '新闻资讯',
			'no-news-data': '新闻找不到了～',
			'news-detail': '新闻详情',
			'report-detail': '研报详情',
			'data-time': '新闻时间',
			'news-updated': '最近更新',
			'news-resource': '数据来源',
			'copy-success': '复制成功',
			'copy-error': '复制失败',


			// 互动问答
			'QA': {
				'search': '请输入关键字筛选提问或回答内容',
				'tab': {
					'meeting': '会议问答',
					'enquiry': '投资者留言',
					'activities': '投关问答',
				},
				'question': '问答',
				'resource': '来源',
				'Q&A': '互动问答'
			},
			'from-leave-message': '来源于',
			'answer-to-message': '回答于：',
			'disclose-to-message': '披露于：',

			// 季度业绩
			//--------- 业绩期
			'results': {
				'annual': '年度',
				'interim': '半年度',
				'first-quarter': '一季度',
				'third-quarter': '三季度',
				'fourth-quarter': '四季度',
			},

			'annual': '年度',
			'interim': '半年度',
			'first-quarter': '一季度',
			'third-quarter': '三季度',
			'fourth-quarter': '四季度',

			//--------- - 内容标题
			'quarter-title': {
				'financial-indicators': '财务数据',  // 季度业绩-内容标题-财务数据
			},
			'results-announcement': '业绩公告',
			'results-summary': '业绩摘要',
			'earnings-calls': '业绩路演',
			'earnings-presentation': '演示材料',
			'business-review-and-outlook': '总结展望',
			'page-version': '一图读懂',
			'earnings-library': '业绩材料',
			'earnings-library--btn': '定期报告',

			'quarter': {
				'financial-indicators': '财务指标', //  季度业绩-财务指标
			},


			// 主要财务指标
			'finance-data': {
				'first-quarter': '一季报',
				'interim': '中报',
				'third-quarter': '三季报',
				'fourth-quarter': '年报',
				'annual': '年报',
			},
			// --  数据指标-每股指标
			'BVPS': '每股净资产',
			'CFPS': '每股现金流',
			'EPS': '每股收益',
			'CapSurFdPS': '每股公积金',
			'UPS': '每股未分配',
			'operating-income-per-share': '每股营收',

			// --  数据指标-偿还能力指标
			'current-ratio': '流动比率',
			'quick-ratio': '速动比率',
			'current-debt-ration': '负债率',
			// --  数据指标-营运能力指标
			'accounts-receivable-turnover': '应收账款周转率',
			'inventory-turnover-ratio': '存货周转率',
			'current-assets-turnover': '流动资产周转率',
			'FATR': '固定资产周转率',
			'ATR': '总资产周转率',
			// --  数据指标-盈利能力指标
			'gross-margin': '毛利率',
			'NPM': '净利润率',
			'ROE': '净资产收益率',
			'ROA': '资产回报率',
			'revenue-growth-rate': '营业收入增长率',
			'operating-profit-grow-rate': '营业利润增长率',
			'net-profit-growth-rate': '净利润增长率',
			'total-assets-growth-rate': '总资产增长率',

			'main-indicators': {
				'financial-indicators': '主要指标',  // 主要财务指标-主要指标
			},

			'YoY': '同比',
			'QoQ': '环比',

			// 利润表
			// 利润表 - 数据指标
			'total-operating-revenue': '营业总收入',
			'total-operating-cost': '营业总成本',
			'operating-profit': '营业利润',
			'total-profit': '利润总额',
			'net-profit': '净利润',
			'net-profit-of-parent-company-owners': '归母净利润',
			'profit': '利润',

			'income-statement': '利润表',

			// 资产负债表
			// 资产负债表 - 数据指标 - 总资产
			'total-assets': '总资产',
			'current-assets': '流动资产',
			'non-current-assets': '非流动资产',
			'money-capital': '货币资金',
			'long-term-loans': '长期借款',
			'owners-equity': '所有者权益',
			// 资产负债表 - 数据指标 - 总负债
			'total-liabilitise': '总负债',
			'current-liabilitise': '流动负债',
			'non-current-liabilitise': '非流动负债',
			// 资产负债表 - 数据指标 - 股东权益
			'shareholders-equity': '股东权益',
			'paid-in-capital': '实收资本或股本',
			'retained-profit': '未分配利润',
			'additional-paid-in-Capital': '资本公积',
			'legal-reserve': '盈余公积',

			'balance-sheet': '资产负债表',

			// 现金流量表
			// 现金流量表 - 数据指标
			'operating-cash-flow': '经营现金流',
			'investing-cash-flow': '投资现金流',
			'finaning-cash-flow': '筹资现金流',
			'cash-flow': '现金流量表',

			// 券商研报
			'research-report-list': '研报列表',
			'research-report': '研报',

			'rating': '券商研报',
			// 券商研报 - 评级
			'buy': '买入',
			'hold': '中性',
			'sell': '卖出',
			'non': '未评级',

			// 公司公告
			'announcement': {
				'all': '全部公告',
			},
			'announcement': '公告',
			'regular-announcement': '定期公告',
			'interim-announcement': '临时公告',

			// 股东结构
			'number-of-shareholders': '股东户数',
			'thousand-households': '万户',
			'percentage-of-change': '较上期变化',
			'average-holding': '户均持股数量',

			'institutional-holding': '机构持股',
			'top-10-holders': '十大股东',
			'top-10-float-holders': '十大流通股东',
			'shareholder': '股东',
			'shareholder-institution': '持股机构',
			'number-of-shares-held': '持股数',
			'proportion-of-total-share-capital': '占总股本比',
			'percentage-of-total-circulating-share-capital': '占总流通股本',
			'QoQ-change': '环比变动',

			// 北上资金
			'holding-date': '持股日期',
			'closing-price': '当日收盘价(元)',
			'daily-change': '当日涨跌幅(%)',
			'number-of-shares-held-(shares)': '持股数量(股)',
			'holding-percentage': '持股数量占比(%)',

			// 融资融卷
			'trading-day': '交易日期',
			'current-financing-balance': '本日融资余额(元)',
			'current-financing-purchase-amount': '本日融资买入额(元)',
			'current-short-selling-balance': '本日融券余量(股)',
			'current-short-selling-volume': '本日融券卖出量(股)',
			'short-selling-balance-amount': '融券余量金额(元)',
			'securities-lending-balance': '融资融券余额(元)',

			// 公募持仓
			'fund-name': '产品名称',
			'percentage-of-circulating-shares': '占流通股比例',

			// 预约调研
			'scheduled-research': '预约调研',

			// 投关日历
			'today': '今',
			'No-events-on-the-selected-date': '所选日期暂无事项',
			'financial-calendar': '投关日历',

			// ESG
			'esg-rating': 'ESG评级',
			'esg-report': 'ESG报告',

			'monday': '一',
			'tuesday': '二',
			'wednesday': '三',
			'thursday': '四',
			'friday': '五',
			'saturday': '六',
			'sunday': '日',

			// 企业管治
			'company-structure': '企业管治',
			'structure-report': '企业管治文件',

			// 标准表单
			'normal-field': {
				'name': '姓名',
				'company': '机构',
				'position': '职位',
				'phone': '联系方式',
				'email': '电子邮箱',
				'success-email': '请填写正确的电子邮箱',
				'verification': '验证码',
				'send-code': '获取验证码',

				'tips': '请填写您的{label}',
				'valid-tips': '请填写您的{label}',

				'subscribe-success': '订阅成功',
				'code-sent-to-email': '验证码已发送至邮件',

				'msg-box': {
					'10015': '您的联系方式已存在，请勿重复订阅',
					'10016': '邮箱已订阅,请勿重复订阅',
					'10017': '您的电子邮箱/联系方式已存在，请勿重复订阅',
					'10018': '验证码发送过于频繁，请稍候再试',
					'10019': '验证码错误',
					'10020': '非法手机号码',
					'10021': '邮箱格式不正确'
				},
				'eventName': '订阅事件',
				'eventName-tips': '请选择订阅事件',
			},
			'subscription-terms': '订阅须知',
			'subscribe': '立即订阅',

			'field': {
				'tips': '请填写{label}',
				'custom-tips': '请填写您的{label}',
				'success-email': '请填写正确的电子邮箱',
			},
			'leave-word': {
				'submitted-tip': '提交成功',
				'result-tip': '亲爱的投资者，您的留言已提交成功，我们将认真听取您的反馈。投资者的声音是我们前进的动力，您的参与将为公司的发展注入新的活力，感谢您的参与！'
			},
			'Busy': '忙碌',

			'message-subscription': {
				'content': '随时了解公司的最新动态和公告，保持与我们的紧密联系，获取及时信息'
			}
		}
	},
	'zh-hk': {
		'enterprise': {
			'no-data': '暫無數據',
			'no-module-data': '暫無模組數據',
			'no-report-data': '研報找不到了～',
			'no-event-data': '活動找不到了～',
			'irstore': '{name}投資者關係',
			'submit': '提交',
			'cancel': '取消',
			'time': '時間',
			'loading': '加載中...',
			'effort-loading': '正在努力加載',

			'report-tips-in-hk09606': '*報告相關內容由第三方信息平臺自動抓取生成。報告中所提及的機構及分析師均非受映恩生物-B（以下簡稱“公司”）委託發表意見。其所提出的任何觀點、估算或預測，僅代表其個人或所在機構的獨立判斷，均不代表公司及其管理層的立場、估計或預測。公司在此類內容中的被提及或對相關內容進行傳閱，並不構成對公司信息、結論或建議的認可或同意。',

			'industry': '所屬行業：',
			// 留言成功提示
			'message-sent-success': '提交成功，感謝您的關注和建議！',
			'error': '服務器錯誤, 請重試',

			'common-a': {
				'updated': '截止時間',
			},
			'common-b': {
				'updated': '數據更新',
			},

			// 其他
			'see-more': '查看更多',
			'view-details': '查看詳情',
			'previes': '預覽',
			'currency-unit': '貨幣單位：',
			'unchanged': '不變',
			'all': '全部',
			'more': '更多',

			// 股票行情
			'high': '最高',
			'low': '最低',
			'P/E': '市盈率(TTM)',
			'P/B': '市淨率',
			'turnover': '成交額',
			'volume': '成交量',
			'market-cap': '總市值',
			'float-cap': '流通值',
			'loss': '虧損',
			'market-quotes': '股票行情',
			'year': '年',
			'day': '日',
			'week': '週',
			'month': '月',
			'candle': 'K線',
			'UTC': '北京時間',
			'ten-thousand': '萬',
			'one-hundred-million': '億',
			'one-trillion': '萬億',
			'div-yied': '股息率(TTM)',

			// 分红配送
			'announced': '公告日',
			'ex-date': '除尽日',
			'record-date': '登記日',
			'payment-date': '派息日',
			'dividend-scheme': '分紅(每10股稅前)',
			'bonus-issue/by-reserve': '送股/轉增(每10股)',
			'dividends': '分紅送配',
			'disclaimer': '進門提供技術支持，僅供交流參考使用，不構成任何投資建議',

			// 投关活动
			'investment': {
				// --------路演状态
				'preview': '預告',
				'live': '直播',
				'playback': '回放',
				'ended': '已結束',
				// --------路演权限
				'audition': '試聽',
				'plubic': '公開',
				'pay': '付費',
				'special': '專場',
				'private': '私密',
				'apply': '報名',
				'member': '會員',
				'institution': '機構通',
				'views': '次瀏覽',
				'summary': '調研紀要',
				'roadshow': '路演會議',
				'activity': '調研活動',
			},
			'IR-events': '投關活動',

			// 新闻资讯
			'news': '新聞資訊',
			'no-news-data': '新聞找不到了～',
			'news-detail': '新聞詳情',
			'report-detail': '研報詳情',
			'data-time': '新聞時間',
			'news-updated': '最近更新',
			'news-resource': '數據來源',
			'copy-success': '復製成功',
			'copy-error': '復製失敗',

			// 互动问答
			'QA': {
				'search': '請輸入關鍵字篩選提問或回答內容',
				'tab': {
					'meeting': '會議問答',
					'enquiry': '投資者留言',
					'activities': '投關問答',
				},
				'question': '問答',
				'resource': '來源',
				'Q&A': '互動問答'
			},
			'from-leave-message': '來源於',
			'answer-to-message': '回答於：',
			'disclose-to-message': '披露於：',

			// 季度业绩
			//--------- 业绩期
			'results': {
				'annual': '年度',
				'interim': '半年度',
				'first-quarter': '一季度',
				'third-quarter': '三季度',
				'fourth-quarter': '四季度',
			},

			'annual': '年度',
			'interim': '半年度',
			'first-quarter': '一季度',
			'third-quarter': '三季度',
			'fourth-quarter': '四季度',

			//--------- - 内容标题
			'quarter-title': {
				'financial-indicators': '財務數據',  // 季度业绩-内容标题-财务数据
			},
			'results-announcement': '業績公告',
			'results-summary': '業績摘要',
			'earnings-calls': '業績路演',
			'earnings-presentation': '演示材料',
			'business-review-and-outlook': '總結展望',
			'page-version': '一圖讀懂',
			'earnings-library': '業績材料',
			'earnings-library--btn': '定期報告',

			'quarter': {
				'financial-indicators': '財務指標', //  季度业绩-财务指标
			},

			// 主要财务指标
			'finance-data': {
				'first-quarter': '一季報',
				'interim': '中報',
				'third-quarter': '三季報',
				'fourth-quarter': '年報',
				'annual': '年報',
			},
			// --  数据指标-每股指标
			'BVPS': '每股淨資產',
			'CFPS': '每股現金流',
			'EPS': '每股收益',
			'CapSurFdPS': '每股公積金',
			'UPS': '每股未分配',
			'operating-income-per-share': '每股營收',

			// --  数据指标-偿还能力指标
			'current-ratio': '流動比率',
			'quick-ratio': '速動比率',
			'current-debt-ration': '資產負債比率',
			// --  数据指标-营运能力指标
			'accounts-receivable-turnover': '應收賬款周轉率',
			'inventory-turnover-ratio': '存貨周轉率',
			'current-assets-turnover': '流動資產周轉率',
			'FATR': '固定資產周轉率',
			'ATR': '總資產周轉率',
			// --  数据指标-盈利能力指标
			'gross-margin': '毛利率',
			'NPM': '淨利潤率',
			'ROE': '淨資產收益率',
			'ROA': '資產回報率',
			'revenue-growth-rate': '營業收入增長率',
			'operating-profit-grow-rate': '營業利潤增長率',
			'net-profit-growth-rate': '凈利潤增長率',
			'total-assets-growth-rate': '總資產增長率',

			'main-indicators': {
				'financial-indicators': '主要指標',  // 主要财务指标-主要指标
			},

			'YoY': '同比',
			'QoQ': '環比',


			// 利润表
			// 利润表 - 数据指标
			'total-operating-revenue': '營業總收入',
			'total-operating-cost': '營業總成本',
			'operating-profit': '營業利潤',
			'total-profit': '利潤總額',
			'net-profit': '淨利潤',
			'net-profit-of-parent-company-owners': '歸母淨利潤',
			'profit': '利潤',

			'income-statement': '利潤表',

			// 资产负债表
			// 资产负债表 - 数据指标 - 总资产
			'total-assets': '總資產',
			'current-assets': '流動資產',
			'non-current-assets': '非流動資產',
			'money-capital': '貨幣資金',
			'long-term-loans': '長期借款',
			'owners-equity': '所有者權益',
			// 资产负债表 - 数据指标 - 总负债
			'total-liabilitise': '總負債',
			'current-liabilitise': '流動負債',
			'non-current-liabilitise': '非流動負債',
			// 资产负债表 - 数据指标 - 股东权益
			'shareholders-equity': '股東權益',
			'paid-in-capital': '實收資本或股本',
			'retained-profit': '未分配利潤',
			'additional-paid-in-Capital': '資本公積',
			'legal-reserve': '盈餘公積',

			'balance-sheet': '資產負債表',

			// 现金流量表
			// 现金流量表 - 数据指标
			'operating-cash-flow': '經營現金流',
			'investing-cash-flow': '投資現金流',
			'finaning-cash-flow': '籌資現金流',
			'cash-flow': '現金流量表',

			// 券商研报
			'research-report-list': '研報列表',
			'research-report': '研報',

			'rating': '券商研報',
			// 券商研报 - 评级
			'buy': '買入',
			'hold': '中性',
			'sell': '賣出',
			'non': '未評級',

			// 公司公告
			'announcement': {
				'all': '全部公告',
			},
			'announcement': '公告',
			'regular-announcement': '定期公告',
			'interim-announcement': '臨時公告',

			// 股东结构
			'number-of-shareholders': '股東戶數',
			'thousand-households': '萬戶',
			'percentage-of-change': '較上期變化',
			'average-holding': '戶均持股數量',

			'institutional-holding': '機構持股',
			'top-10-holders': '十大股東',
			'top-10-float-holders': '十大流通股東',
			'shareholder': '股東',
			'shareholder-institution': '持股機構',
			'number-of-shares-held': '持股數',
			'proportion-of-total-share-capital': '佔總股本比',
			'percentage-of-total-circulating-share-capital': '占總流通股本',
			'QoQ-change': '環比變動',

			// 北上资金
			'holding-date': '持股日期',
			'closing-price': '當日收盤價(元)',
			'daily-change': '當日漲跌幅 (%)',
			'number-of-shares-held-(shares)': '持股數量(股)',
			'holding-percentage': '持股數量占比(%)',

			// 融资融卷
			'trading-day': '交易日期',
			'current-financing-balance': '本日融資餘額(元)',
			'current-financing-purchase-amount': '本日融資買入額(元)',
			'current-short-selling-balance': '本日融券餘量(股)',
			'current-short-selling-volume': '本日融券賣出量(股)',
			'short-selling-balance-amount': '融券餘量金額(元)',
			'securities-lending-balance': '融資融券餘額(元)',

			// 公募持仓
			'fund-name': '產品名稱',
			'percentage-of-circulating-shares': '占流通股比例',

			// 预约调研
			'scheduled-research': '預約調研',

			// 投关日历
			'today': '今',
			'No-events-on-the-selected-date': '所選日期暫無事項',
			'financial-calendar': '投關日曆',

			// ESG
			'esg-rating': 'ESG評級',
			'esg-report': 'ESG報告',

			'monday': '一',
			'tuesday': '二',
			'wednesday': '三',
			'thursday': '四',
			'friday': '五',
			'saturday': '六',
			'sunday': '日',

			// 企业管治
			'company-structure': '企業管治',
			'structure-report': '企業管治文件',

			// 标准表单
			'normal-field': {
				'name': '姓名',
				'company': '機構',
				'position': '職位',
				'phone': '聯繫方式',
				'email': '電子郵箱',
				'success-email': '請填寫正確的電子郵件',
				'verification': '驗證碼',
				'send-code': '獲取驗證碼',

				'tips': '請填寫您的{label}',
				'valid-tips': '請填寫您的{label}',

				'subscribe-success': '訂閱成功',
				'code-sent-to-email': '驗證碼已發送至郵件',

				'msg-box': {
					'10015': '您的聯繫方式已存在，請勿重複訂閱',
					'10016': '郵箱已訂閱,請勿重複訂閱',
					'10017': '您的電子郵箱/聯繫方式已存在，請勿重複訂閱',
					'10018': '驗証碼髮送過於頻繁，請稍候再試',
					'10019': '驗證碼錯誤',
					'10020': '非法手機號碼',
					'10021': '郵箱格式不正確'
				},
				'eventName': '訂閱事件',
				'eventName-tips': '請選擇訂閱事件',
			},
			'subscription-terms': '訂閱須知',
			'subscribe': '立即訂閱',

			'field': {
				'tips': '請填寫{label}',
				'custom-tips': '請填寫您的{label}',
				'success-email': '請填寫正確的電子郵件',
			},
			'leave-word': {
				'submitted-tip': '提交成功',
				'result-tip': '親愛的投資者，您的留言已提交成功，我們將認真聽取您的反饋。投資者的聲音是我們前進的動力，您的參與將爲公司的發展注入新的活力，感謝您的參與！'
			},
			'Busy': '忙碌',

			'message-subscription': {
				'content': '隨時了解公司的最新動態和公告，保持與我們的緊密聯繫，獲取及時信息'
			}
		}
	},
}

export default {
	en: {
		...AREACODE.en,
		...enterpriseModule['en'],

		"欢迎登录进门": "Welcome to Comein",
		"未注册手机号验证通过后将自动注册": "Unregistered cell phone number will be automatically registered after verification",
		"验证码登录": "Verification code",
		"密码登录": "Password",
		"请输入手机号": "Phone number",
		"请输入验证码": "Verification code",
		"请输入手机号/邮箱/进门号": "Phone number/email/Comein ID",
		"请输入密码": "Password",
		"登 录": "Sign in",
		"登录": "Sign in",
		"进门登录": "Sign in",
		"使用微信登录": "Sign in with WeChat",
		"我已阅读并同意《用户协议》和《隐私政策》": "I have read and agree to the 《User Agreement 》and the 《Privacy Policy》",
		"我已阅读并同意": "I have read and agree to the ",
		"阅读并同意": "I have read and agree to the ",
		"用户协议": "User Agreement",
		"隐私政策": "Privacy Policy",
		"微信授权": "WeChat authorization",
		"获取手机号": "Get mobile number",
		"获取用户信息": "Get user information",
		"微信集成（手机号）登录": "Sign in with phone number",
		"使用进门账号登录": "Sign in with Comein account",
		"服务协议与隐私政策《用户协议》和《隐私政策》": "Service Agreement and Privacy Policy 《User Agreement》 and the 《Privacy Policy》",
		"不同意": "Disagree",
		"同意并继续": "Agree and continue",
		"获取验证码": "Send code",
		"取消": "Cancel",
		"保存": "Save",
		"账号不能为空": "Account cannot be empty",
		"密码不能为空": "Password cannot be empty",
		"手机号不能为空": "Mobile number cannot be empty",
		"验证码不能为空": "verification cannot be empty",
		"正在登录": "Signing in",
		"请输入8-11位的手机号码": "Please enter 8-11 digit phone number",
		"请允许授权": "Please allow authorization",
		"提示": "Tips",
		"账号或密码错误，请重新输入": "Wrong account or password, please re-enter",
		"密码错误次数过多，可尝试使用手机验证登录": "Password error too many times, you can use the verification code to sign in",
		"和": "and the",
		"密码错误次数过多，请半小时过后登录，可选择手机验证码登录，或找回密码": "Password error too many times, please sign in after half an hour, you can choose cell phone verification code sign in, or sign in cell phone APP to retrieve the password",
		"密码错误次数过多，请半小时过后登录，可选择手机验证码登录，或登录手机APP找回密码": "Password error too many times, please sign in after half an hour, you can choose cell phone verification code sign in, or sign in cell phone APP to retrieve the password",

		"请输入6-20位包含字母和数字的密码": "Enter a 6-20 alphanumeric password",
		"选择区号": "Select area code",
		"验证码已经发送成功": "Verification code has been sent successful",
		"s后重发": "s re-posted after",
		"服务协议与隐私政策": "Service Agreement and Privacy Policy",
		"阅读并同意《用户协议》和《隐私政策》": "I have read and agree to the 《User Agreement》 and the 《Privacy Policy》",
		"网络较差，请稍后重试": "Poor network, please retry later",
		"账号或密码错误": "Account or password error",
		"手机号格式错误": "Wrong format of phone number",
		"手机号码错误": "Wrong phone number",
		"注册成功": "Sign up successful",
		"验证码不正确": "Verification code error",
		"用户不存在": "User does not exist",
		"不要频繁发送，请稍后再试": "Don't send frequently, please retry later",
		"绑定成功": "Binding successful",
		"验证": "Verify",
		"验证码已经失效": "Verification code has expired",
		"请阅读并勾选协议": "Please read and check the agreement",
		"密码需包含字母和数字，长度为6-20位": "Password should contain letters and numbers and be 6-20 digits long",
		"密码错误次数过多，请半小时后登录，可选择手机验证码登录，或找回密码": "Password error too many times, please sign in after half an hour, you can choose phone verification code sign in, or retrieve the password",
		"网络不给力，请稍后重试": "Network does not work, please try again later",
		"网络请求失败": "Network request failed",
		"请不要重复提交": "Please do not submit again",
		"验证码错误": "Verification code error",

		// 申请参会
		"申请参会": "Apply to participate",
		"申请线下参会": "Attend On-Site",
		"机构投资者": "Institution",
		"个人投资者": "Individual",
		"其他机构": "Others",
		"请上传纸质名片/其他有效证件": "Please upload a paper business card/other valid documents",
		"请确保名片中包含姓名、公司、职位和手机号": "Please ensure the name, company, title, and phone number are clear.",
		"姓名": "Name",
		"请输入真实姓名": "Full name",
		"公司": "Company",
		"请输入公司名称": "Company name",
		"职位": "Title",
		"请输入职位，如：投资经理": "I.e. Portfolio Manager",
		"用户类型": "Type",
		"请选择用户类型": "Choose user type",
		"参会号码": "Tel.",
		"邮箱": "Email",
		"请输入邮箱地址": 'Email address',
		"手写签字": "Signature",
		"添加签字": "Go sign",
		"我已阅读并同意": "I have read and agree:",
		"承诺书": "Agreement",
		"提交申请": "Submit",
		"申请提交": "Submit",
		"提交": "Submit",
		"选填": "Optional",
		"活动已结束": "Event ended",
		"活动已取消": "Event cancelled",
		"备用号码": "Alt. Tel.",
		"区号": "Area code",
		"请输入号码": "Phone Number",
		"请输入备用号码": "Landline Number",
		"请输入分机号": "Extension",
		"是否需要外呼": "Call-in required",
		"如果您选择需要外呼，会议开始前系统将拨入您提交的参会手机号": "Participate by receiving an out-bound call from the organizer",
		"需要": "Yes",
		"不需要": "No",
		"用户须对所提供座机号的真实性、合法性、有效性承担全部责任，用户不得随意填写他人座机号；否则进门有权立即停止提供相关服务，并由用户独自承担因此而产生的一切法律责任！": "The user shall assume full responsibility for the authenticity, legality and validity of the landline number provided, and the user shall not fill in another person's landline number at will;otherwise, Comein Finance has the right to immediately stop providing the relevant services, and the user alone shall bear all legal responsibilities arising therefrom!",
		"我知道了": "I know",
		"请填写区号": "Please fill in the area code",
		"请填写号码": "Please fill in the number",

		"申请参会": "Apply to participate",
		"重新提交": "Resubmit",
		"姓名": "Name",
		"请输入真实姓名": "Full name",
		"公司": "Company",
		"请输入公司名称": "Company name",
		"职位": "Title",
		"邮箱": "Email",
		"联系电话": "telephone",
		"微信号": "wechat",
		"请输入职位，如：投资经理": "I.e. Portfolio Manager",
		"用户类型": "Type",
		"请选择用户类型": "Choose user type",
		"承诺书": "Agreement",
		"查看": "Check",
		"其他": "Other",
		"无": "None",
		"审核中": "Under review",
		"已报名": "Registered",
		"问卷描述": "Questionnaire",
		"人": "people",
		"联系我们": "Contact Us",
		"查看全部": "View All",
		"海报图": "Poster image",
		"上传名片": "Business card",
		"上传名片/有效证件": "Business Card/Valid ID",
		"上传名片后将自动填充个人信息": "Information will be automatically filled in after uploading your business card/valid ID.",
		"去上传": "Upload",
		"接待人": "Receptionist",
		"未审核": "Unreviewed",
		"资料已提交成功，请留意短信通知": "The information has been submitted successfully, please pay attention to the SMS notification",
		"审核失败": "Review failed",
		"未通过原因请查看提示内容": "Please check the prompt content for the reason of failure",
		"提交成功，请等待审核": "Submitted successfully, please wait for confirmation",
		"提交成功": "Submitted successfully",
		"申请未通过": "Application failed",
		"审核未通过": "Review failed",
		"备用号码": "Alt. Tel.",
		"区号": "Area code",
		"号码": "Number",
		"是否需要外呼": "Call-in required",
		"如果您选择需要外呼，会议开始前系统将拨入您提交的参会手机号": "Participate by receiving an out-bound call from the organizer",
		"需要": "Yes",
		"不需要": "No",
		"用户须对所提供座机号的真实性、合法性、有效性承担全部责任，用户不得随意填写他人座机号；否则进门有权立即停止提供相关服务，并由用户独自承担因此而产生的一切法律责任！": "The user shall assume full responsibility for the authenticity, legality and validity of the landline number provided, and the user shall not fill in another person's landline number at will;otherwise, Comein Finance has the right to immediately stop providing the relevant services, and the user alone shall bear all legal responsibilities arising therefrom!",
		"我知道了": "I know",
		"会议主题": "Theme",
		"会议时间": "Time",
		"审核通过": "Approved",
		"报名成功，待主办方审核": "Registration is successful",
		"审核结果将以短信的方式发送，请留意": "The review result will be sent by SMS",
		"进入会议": "Enter",
		"返回": "Return",
		"正在识别": "Scanning",

		"报名已结束": "报名已结束（Ends）",
		"申请不通过，点击重新提交": "Application failed, click to resubmit",
		"申请参会": "Register",
		"申请通过，点击参会": "Application passed, click to participate",
		"点击参会": "Click to participate",

		"选择公司": "Choose a company",
		'没找到？点击“完成”选择已输入的公司': `Did not find? Click "Complete" to select the entered company`,
		"完成": "Complete",
		"历史记录": "History record",
		"确认删除全部历史记录？": "Are you sure you want to delete all history?",
		"确定": "Confirm",
		"请输入公司名称": "Company name",

		"活动介绍": "Event",
		"嘉宾介绍": "Speakers",
		"会议议程": "Agenda",
		"公司介绍": "Company",
		"会议介绍": "About the Event",
		"会议嘉宾": "Speakers",
		"会议流程": "Agenda",
		"自定义栏目": "custom column",
		"报名截止时间": "Registration Deadline",
		"加日程": "add schedule",
		"未开始": "Upcoming",
		"参会方式": "How to Participate",
		"请输入": "Please enter ",
		"请选择": "Please select ",
		"请上传": "Please upload",
		"请输入 (选填)": "Please enter",
		"请选择 (选填)": "Please select",
		"立即注册": "Sign up",
		"手机号注册": "Phone number",
		"邮箱注册": "Email",
		"已有账号？": "Already have an account? ",
		"去登录": "Go to sign in",
		"注册": "Sign up",
		"报名": "Sign up",
		"报名正在审批中，主办方通过后即可签到": "Sign-in available upon approval.",
		"抱歉！您的报名申请并未通过，无法参与本次活动": "Registration application denied.",
		"设置头像": "Photo",
		"更换头像": "Photo",
		"昵称": "Nickname",
		"欢迎注册进门": "Welcome to Comein",
		"请上传图片格式文件": "Please upload image format file",
		"上传文件太大，请重新上传": "The uploaded file is too large, please re-upload",
		"未选择上传图片": "Upload image not selected",
		"上传文件": "Upload file",

		"简介": "About the Event",
		"请输入您的昵称": "Your nickname",
		"请输入您的个人简介": "Your profile",
		"忘记密码": "Forget password",
		"重置密码": "Reset password",
		"手机号找回": "Phone number",
		"邮箱找回": "Email",
		"下一步": "Next",
		"密码不一致": "Inconsistent passwords",
		"重置账号密码成功": "Reset password successful",
		"包含违规词汇": "Contains sensitive words",
		"等": " etc",
		"绑定手机": "Bind phone",
		"跳过": "Skip",
		"绑定手机号成功": "Bind mobile phone number successfully",
		"请再次输入密码": "Confirm password",
		'该手机号已被注册绑定': "The phone number has been registered and bound",
		"该邮箱已注册": "The mailbox has been registered",
		"您的手机号已经被注册了": "Your mobile phone number has been registered",
		"您的邮箱格式不正确": "Email format error",
		"密码需包含数字和字母，长度为6-20位": "Password should contain letters and numbers and be 6-20 digits long",
		"用户昵称被占用": "User nickname is occupied",

		"姓  名": "Name",
		"参会号码": "Tel",
		"邮  箱": "Email",
		"公司名称": "Company",
		"请输入参会姓名": "Your name",
		"请输入参会号码": "Phone number",
		"请输入邮箱地址": "Email address",
		"请输入公司名称（选填）": "Company Name",
		"请填写参会号码或邮箱": "Please enter your number or email",
		"请填写正确的参会号码": "Please enter your number",
		"请填写正确的邮箱": "Incorrect mailbox format",
		"您暂无观看权限": "No viewing permission",

		"天": "d",
		"小时": "h",
		"时": "h",
		"分": "m",
		"秒": "Sec",
		"距离会议开始": "In",
		"直播即将开始": "About to start",
		"待开始": "Upcoming",
		"已取消": "Cancelled",
		"正在直播": "Live",
		"本场路演结束，感谢参与": "The meeting has ended, thank you for participating",
		"「投研秘书」为您提供章节点播与内容纪要服务": "「Investment research secretary」 Provide you with services such as chapter on-demand and content summary",
		"投研秘书": "Investment research secretary",
		// "会员": "Membership",
		"付费": "Pay",
		"试听": "Audition",
		"已关注": "Followed",
		"关注": "Follow",
		"路演介绍": "Introduction",
		"占位符": "",
		"会议日程": "Meeting schedule",
		"版权声明": "Copyright notice",
		"为您提供章节点播与内容纪要等服务": "Provide you with services such as chapter on-demand and content summary",
		"路演章节": "Chapter",
		"路演文档": "Document",
		"本场路演投研秘书服务": "Investment research secretary for this meeting",
		"继续支付": "Continue to pay",
		"购买": "Purchase",
		"相关路演": "Related roadshows",
		"我也是有底线的": "No more content",
		"本场路演不支持提问": "This meeting does not support questions",
		"提问": "Q",
		"购买会员": "Purchase membership",
		"占位专用": "",
		"重新报名": "Re-register",
		'重新认证': "Re-authenticate",
		"已提交报名，请等待审核": "Registration submitted, please wait for confirmation",
		"已提交机构投资者认证，请等待审核": "Submitted Institutional certification, please wait for confirmation",
		"购买完成": "Purchase completed",
		"暂无提问": "No questions",
		"请先登录账号": "Please sign in first",
		"请先登录进门账号": "Please sign in to Comein first",
		"请先购买后观看": "Please purchase first",
		'私密类型路演暂不支持此操作': "Private type roadshow does not support this operation temporarily",
		"路演准备中，请稍候查看": "Roadshow is preparing, please check later",
		"添加关注成功": "Add follow successfully",
		"已取消关注": "Unfollowed",
		"报名审核中，请稍后": "Registration submitted, please wait for confirmation.",
		"报名审核中": "Registration submitted, please chack later",
		"报名审核通过": "Registration approved",
		"报名审核未通过": "Re-register",
		"报名审核未通过，请重新报名": "Registration rejected, please re-register",
		"活动报名已结束": "Registration Ended",
		"观看权限已过": "Viewing privileges have expired",
		"认证机构投资者": "Certification Institutional",
		"认证审核通过": "Certification passed",
		"认证审核未通过": "Certification failed",
		"认证审核中，请稍后": "Certification is under review, please check later",
		"应主办方要求，本次路演未保留回放": "No replay will be kept for this session",
		"查看详情": "View details",
		"购买专栏": "Purchase column",
		"路演结束后发布，请稍后": "Meeting will be released after it ends, please check later",
		"文字路演": "Text roadshow",
		"抱歉，本场路演暂不支持提问": "Sorry, this meeting does not support questions",
		"回放生成中，请稍后关注": "Playback is being generated, please pay attention later",
		"嘉宾正在准备路演，请稍等": "The guest is preparing for the roadshow, please wait a moment",
		"即将开始": "About to start",
		"添加收藏成功": "Collection succeeded",
		'已取消收藏': "Unfavorited",
		"参数错误": "Parameter error",
		"进门路演会议": "Comein roadshow",
		"路演时间": "Roadshow time",
		"点击链接参与": "Click the link to participate",
		"购买后可观看": "Watch after purchase",
		"当前路演": "Current",
		"牛币": "Niu coin",
		"续费至": "Renew to",
		"详情": "Details",
		"问答": "Question",
		"文档": "Document",
		"详情介绍": "Detail introduction",
		"相关路演": "Related roadshow",
		"课程目录": "Course catalog",
		"专栏目录": "Column catalog",
		"路演": "Roadshow",
		"万": "W",
		"暂停销售": "Sold out",
		"该路演暂停销售": "This roadshow is sold out",
		"起": "+",
		"限时免费": "Free",
		"确认购买": "Confirm purchase",
		"课程": "Course",
		"购买课程": "Purchase course",

		"仅购买本场路演": "Only purchase this roadshow",
		'个月': "month",
		"长期有效": "Permanent",
		"请下载“进门”APP 购买": "Please download the Comein app to purchase",
		"知道了": "Got it",
		"已购买该专栏": "Purchased this column",
		'已购买该课程': "Purchased this course",
		'该课程暂停销售': "This course is sold out",

		"打开APP": "Open the app",
		"打开APP，精彩路演会议不容错过": "Open the app, don't miss the roadshow",
		"打开APP，进行举手语音提问吧": "Open the app, raise your hand and ask questions by voice",
		"打开APP，参与路演会议体验更顺畅": "Open the app, participate in the roadshow for a better experience",

		"搜索": "Search",
		"下载APP": "Download",
		"首页": "Home",
		"下载进门APP，查看更多精彩内容": "Download the Comein app to view more",
		"立即下载": "Download now",
		"请输入关键字": "Please enter keywords",
		"确认": "Confirm",
		"暂无文档": "No document",

		"密码输入错误，请重新输入": "Password is incorrect, please try again",
		"'你已被提升为'嘉宾'身份'": "You have been promoted to the guest identity",
		"你已被取消'嘉宾'身份": "You have been canceled as a guest",
		"本场路演仅可提问": "Only questions are allowed in this roadshow",
		"您的账号已在其他地方登录": "Your account has been logged in elsewhere",
		"该路演已被主讲删除": "The roadshow has been deleted by the speaker",
		"未直播": "Not live",
		"直播已开始，点击播放": "Live has started, click to play",
		"你已被限制观看本场路演，可联系主讲人申请观看": "You have been restricted from watching this roadshow, please contact the speaker to apply for viewing",
		"在这里输入聊天内容": "Enter chat content here",
		"本场路演暂不支持提问": "Does not support questions",
		"本场路演仅支持提问": "Just supports questions",
		"在这里输入提问内容": "Enter question content here",
		"宣传片": "Promotional video",
		"直播尚未开始,请先观看宣传片": "The live has not started yet, please watch the promotional video first",
		"直播尚未开始，可先观看相关宣传视频，是否播放？": "The live has not started yet, you can watch the promotional video first, do you want to play it?",
		"往期回放": "Past playback",
		"点击刷新": "Click to refresh",
		"刷新完成": "Refreshed",
		"视频加载失败": "Video loading failed",
		"网络不稳定": "Network unstable",
		"努力加载中": "Loading",
		"加载中": "Loading",
		"正在播放中": "Playing",
		"您终止了播放": "You stopped playing",
		"网络错误": "Network error",
		"解码错误": "Decode error",
		"无效的地址": "Invalid address",
		"快进": "Fast forward",
		"快退": "Fast rewind",
		"倍数": "Speed",
		"断开连接，重连中": "Disconnected, reconnecting",
		"当前未直播，请稍后关注": "Not live now, please follow later",
		"路演未开始，请稍后关注": "Roadshow has not started, please follow later",
		"您已连接 PPT 同步": "You have connected PPT synchronization",
		"您已断开 PPT 同步": "You have disconnected PPT synchronization",
		"请输入直播厅密码": "Please enter the live room password",
		"根据举办方要求": "According to the organizer's requirements",
		"本场为内部交流，不对外开放": "Meeting is private",
		"实名认证申请通过即可观看": "You can watch after your real-name authentication application is approved",
		"实名认证": "Real-name authentication",
		"该账号已在其他设备登录，为保证账号安全，请重新登录": "This account has been signed in on another device. To ensure account security, please sign in again",
		"您的账户在另一地点登录": "Your account is logged in elsewhere",
		"重新登录": "Re-login",
		"立即认证": "Authenticate",
		"审核不通过": "Review failed",
		"撤回了一条消息": "Withdraw a message",
		"发了个红包": "Sent a red package",
		"立即查看": "View now",
		"打赏了": "Rewarded",
		"您有1条新回复": "You have 1 new reply",
		"我的提问": "My questions",
		"已上墙": "Posted",
		"待上墙": "Pending",
		"您已被禁言": "You have been muted",
		"输入内容为空": "Input is empty",
		"提问成功，请在提问列表查看": "Question submitted successfully, please check the question list",
		"问": "Q",
		"继续访问外部链接？": "Continue to access external links?",
		"关闭": "Close",
		"是": "Yes",
		"下载进门APP抢红包": "Download the Comein app to grab the red package",
		"下载进门APP查看文件": "Download the Comein app to view the file",
		"昨天": "Yesterday",
		"查看更多": "View more",
		"正在加载": "Loading",
		"暂无内容": "No content",
		"发送": "Send",
		"无对应回放音视频": "No playback audio/video",
		"购买后可观看路演": "Buy to watch the roadshow",
		"下载中": "Downloading",
		"已下载": "Downloaded",
		"下载": "Download",
		"章节": "Chapter",
		"此路演暂无章节信息": "No chapter information for this roadshow",
		"回放已下载到我的文件": "Playback has been downloaded to my files",
		"回放正在下载到我的文件": "Playback is being downloaded to my files",
		"此路演暂不可下载": "This roadshow is not available for download",
		"播放签到失败": "Failed to play sign-in",
		"数据请求中": "Requesting data",
		"没有播放地址，却没有签到失败": "No playback address, but no sign-in failure",
		"次播放": "Times played",
		"次浏览": "Times viewed",
		"回放": "Playback",
		"置顶": "Top",
		"有效期": "Valid period",
		"移出会议": "Remove from meeting",
		"讲": "Lesson",
		"预约成功，可在日历菜单查看": "Appointment successful, you can view it in the calendar menu",
		"已取消路演会议预约": "Roadshow meeting appointment cancelled",
		"会议已结束，请稍后观看回放": "Meeting has ended, please watch the playback later",
		"会议已结束，本场会议不提供回放": "Meeting has ended, this meeting does not provide playback",
		"预约失败": "Appointment failed",
		"永久有效": "Permanent",
		"报名审批中": "Application under review",
		"报名不通过": "Application failed",
		"报名已通过": "Application approved",
		"报名已截止": "Registration closed",
		"现场报名已截止": "Registration closed",
		"报名成功": "Application successful",
		"我": "Me",
		"应举办方要求需签署承诺书，方可观看": "You need to sign a commitment letter as required by the organizer to watch",
		"确 定": "Confirm",
		"我已经加载完了": "I have loaded it",
		"当前没有消息": "No message",
		"暂无数据": "No data",
		"下拉刷新": "Pull down to refresh",
		"释放加载": "Release to load",
		"正刷新中": "Refreshing",
		"刷新成功": "Refreshed successfully",
		"正在努力加载": "Loading",
		"已预约": "Booked",
		"预约": "Book",
		"预告": "Preview",
		"直播": "Live",
		"报名": "Register",
		"预约成功，可在“我的路演”或“进门APP日历”菜单中查看": "Appointment successful, you can view it in the \"My Roadshow\" or \"Comein Calendar\" menu",
		"下载回放": "Download playback",
		"打开“进门”APP，下载回放观看，精彩路演不错过！": "Open the \"Comein\" app, download the playback to watch, don't miss the wonderful roadshow!",
		"网络异常，请检查后重试": "Network error, please check and try again",
		"直播中": "Live",
		"提交参会信息后，即可进入会议": "After submitting the meeting information, you can enter the meeting",
		"参会信息": "Join the meeting",
		"路演回放": "Playback",
		"路演厅": "Roadshow",
		"分析师直播": "Analyst Roadshow",
		"路演详情": "Details",
		"进门": "Comein",
		"个": "",
		"点击可切换至PPT模式": "Click to switch to PPT mode",

		"预约成功": "Appointment successful",
		"当前路演直播已开始": "The current roadshow live broadcast has started",
		"当前路演已发回放": "The current roadshow has been sent back",
		"观看回放": "Watch playback",
		"嘉宾正在准备路演，请稍后": "Guests are preparing for the roadshow, please wait",
		"会议已结束": "Meeting ended.",

		"本场路演仅针对<span>白名单</span>客户开放": "The meeting just open to <span>whitelist users</span>",
		"本场路演需购买<span>课程</span>后才能观看": "Watch after <span>Purchase course</span>",
		"本场路演需<span>报名</span>审核通过才能参会": "<span>Registration</span> Required",
		"本场路演需购买<span>专栏</span>后才能观看": "Watch after <span>Purchase column</span>",
		"本场路演需购买<span>会员</span>后才能观看": "Watch after <span>Purchase membership</span>",
		"本场路演需<span>购买</span>后才能观看": "Watch after <span>Purchase</span>",
		"本场路演需完成<span>机构投资者认证</span>才能参会": "Join after complete <span>institutional investor certification</span>",
		"预约成功，可在“我的路演”或“进门<br>APP日历”菜单中查看": "Appointment successful, you can view it in the \"My Roadshow\" or \"Comein Calendar\" menu",
		"应小程序要求，该路演请前往<span>进门APP</span>观看": "Due to the requirements of the mini program, the roadshow please go to <span>Comein APP</span> to watch",

		"立即购买": "Purchase now",

		"机构通": "Institution",
		"私密": "Private",
		"专场": "Special",
		"会员": "Member",
		"付费": "Pay",
		"报名参会": "Apply",

		"路演准备中，可先观看相关宣传视频，是否播放？": "The roadshow is preparing, you can watch the related promotional video first, whether to play?",
		"请稍等，路演会议即将开始": "Please wait, roadshow will start soon",
		"路演会议": "Roadshow",
		"路演主题": "Roadshow",
		"主讲人": "Presenter",
		"主持人": "Moderator",
		"嘉宾": "Speakers",
		"免责声明": "Disclaimers",
		"路演准备中，准备完毕后会将您接入路演厅中": "Preparing, you will be connected later",
		"你没有参会权限，请退出重试": "You do not have permission to attend, please exit and try again",
		"网络异常，请检查网络设置，或尝试重新入会。": "Network abnormalities, please check the network settings, or try to rejoin the club",
		"离开会议": "Leave",
		"重新入会": "Rejoin",
		"网络异常，请稍后再试": "Network abnormality, please try again later",

		"问题征集": "Questionnaire",
		"请输入提问内容": "Please enter your question",
		"暂不支持此类会议": "Unsupported meeting type.",
		"会议不允许预提问": "Pre-questions prohibited",
		"提问": "Ask a question",
		"提问已关闭": "Questions closed",
		"问题征集已关闭": "Questions closed",
		"还可输入": "You can also enter ",
		"字": " characters",
		"扫一扫观看路演": "watch the meeting",
		"问题提交成功，感谢您的关注": "Problem submitted successfully",
		"获取邀请函": "Ticket",

		"进行中": "In progress",
		"已结束": "Ended",
		"活动时间": "Activity time",
		"举办方": "Organizer",
		"联系人": "Contact",
		"活动地址": "Address",
		"线下": "Offline",
		"线上": "Online",
		"专题会议": "Special",
		"线上+线下": "Online+Offline",
		"立即报名": 'Apply now',
		"活动详情": "Details",
		"咨询": "Support",
		"日历": "Calendar",
		"活动地点及联系人线下报名成功后可见": "The location and contact person of the event will be visible after successful offline registration",
		"参会密码": "Meeting Password",
		"晚宴介绍": "Dinner introduction",
		"进门号": "Comein ID",
		"报名通过后可见": "Visible after registration",
		"活动已截止": "Event is closed",
		"进门APP/H5/小程序": "Mobile(Via Comein APP/H5/Mini Program)",
		"PC端": "Website",
		"APP/小程序": "APP/Mini Program",
		"电话接入": "Dial by your location",
		"报名参与上市公司调研活动": "Apply for participation in listed company research activities",
		"审批中": "In review",
		"观看路演": "Watch the roadshow",
		"参与路演": "Participate in the roadshow",
		"报名审核已通过，请按时参加": "The registration review has been passed, please participate on time",
		"活动报名时间已截止！": "The event registration time has ended!",
		"报名失败": "Registration failed",
		"主办方": "Organizer",
		"活动": "Activity",
		"地址": "Address",
		"请上传纸质名片": "Please upload paper business card",
		"必填": "Required",
		"请输入身份证号": "Please enter ID number",
		"您的报名已提交，审核通过后将自动签到": "Your registration has been submitted, and you will be automatically checked in after the review",
		"签到": "Check in",
		"活动签到": "Check in",
		"识别失败，请重新上传或手动填写": "Recognition failed, please re-upload or fill in manually",
		"调研活动不存在": "Research activities do not exist",
		"获取地理位置失败，请重新授权": "Failed to get location, please re-authorize",
		"已成功提交报名，请耐心等待报名结果通知": "The registration has been successfully submitted, please wait patiently for the registration result notification",
		"已完成登记报名，请完成活动签到": "The registration has been completed, please complete the event check-in",
		"该活动仅限机构投资者参加，请前往认证": "This event is only open to institutional investors, please go to certification",
		"您填写的公司属于“": "The company you filled in belongs to '",
		"”，与选择的用户类型不一致，是否修改成一致并提交": " ', inconsistent with the selected user type, whether to modify it to be consistent and submit",
		"忽略并提交": "Ignore",
		"修改并提交": "Submit",
		"机构投资者公司": "Institutional investor company",
		"分析师研究所": "Analyst Research Institute",
		"上市公司董监高公司": "Listed company board of directors and supervisors",
		"您提交的公司": "The company you submitted",
		"与您认证的": "is inconsistent with your certification",
		"不一致": "Inconsistent",
		"为确保您的参会权限，请您及时更新": "To ensure your participation rights, please update",
		"认证信息": "Certification information",
		"温馨提示": "Tips",
		"去更新": "Update",
		"忽略": "Ignore",
		"请选择您的类型": "Please select your company",
		"公募": "Mutual fund firm",
		"私募": "Private-equity firm",
		"其他": "Other",
		"保险公司": "Insurance company",
		"信托公司": "Trust company",
		"券商资管": "Asset management firm",
		"券商自营": "Securities brokerage firm",
		"期货公司": "Futures brokerage firm",
		"银行": "Bank",
		"券商研究所": "Research institute",
		"境外机构": "Institutions outside Mainland China",
		"银行理财": "Bank wealth management",
		"报名限额": "Registration quota",
		"签到成功": "Check-in successful",
		"活动已取消，暂不支持签到": "Check-in is not available",
		"您的活动报名审核中，不支持签到": "Your event registration is under review and does not support check-in",
		"您的活动报名审核未通过，不支持签到": "Your event registration has not passed the review and does not support check-in",
		"活动已过期，不支持签到": "The event has expired and does not support check-in",
		"活动已完成，不支持签到": "The event has been completed and does not support check-in",
		"行业": "Industry",
		"您的报名已通过，可直接入会": "Your registration has been passed, you can join the meeting directly",
		"会议活动已失效": "The meeting activity has expired",
		"您已在白名单内，可直接入会": "You are already on the whitelist and can join the meeting directly",
		"会前问题收集": "Question Collection",
		"请输入您想了解的问题": "Enter your question.",
		"基本信息": "Basic Information",
		"其他信息": "Other information",
		"报名券商": "Securities company",
		"是否外呼": "Call-in required",
		"承诺书签署": "Sign the agreement",
		"删除": "Delete",
		"重写": "Rewrite",
		"名片信息已自动填充": "Business card information has been filled in",
		"重新上传": "Reupload",
		"名片内容信息识别": "Recognition",
		"成功": "Successful",
		"失败": "Failed",
		"名片内容信息识别成功": "Recognition Successful",
		"名片内容信息识别失败": "Recognition Failed",
		"您所预约调研的公司": "The company you have booked for research",
		"此页面帮助上市公司提前收集会议问题，将会统一在会议中答复": "This page helps listed companies collect meeting questions in advance and will provide unified answers during the meeting.",
		"中国标准时间 - 北京": "China Standard Time - Beijing",

		"请在空区域横向手写": 'Please write horizontally in the empty area',
		"重写": 'Rewrite',
		"确定保存该签名": 'Sure to save the signature',
		"取消": 'Cancel',
		"删除": 'Delete',
		"添加签名": 'Signature',
		'确定签名即代表您已阅读全部签署文件且同意本次签名，是否确认提交?': 'I have read the agreement and agree to sign it.',
		'本次会议需要您签署承诺书，签名代表您已阅读并同意': 'This conference requires you to sign the commitment letter, which means that you have read and agreed',
		'去签名': 'Go sign',
		'确认签名': 'Confirm signature',
		'签名即代表您已阅读并同意': 'I have read and agree:',
		"请在空区域横向手写": 'Please write horizontally in the empty area',
		"重写": 'Rewrite',
		"确定": 'Confirm',
		"确认": 'Confirm',
		"确定保存该签名": 'Sure to save the signature',
		"取消": 'Cancel',
		"删除": 'Delete',
		"添加签名": 'Signature',
		'请签署清晰的签名，以确保签名的准确性': 'Please provide a clear signature.',
		'确定签名即代表您已阅读全部签署文件且同意本次签名，是否确认提交?': 'I have read the agreement and agree to sign it. ',
		'本次会议需要您签署承诺书，签名代表您已阅读并同意': 'This conference requires you to sign the commitment letter, which means that you have read and agreed',
		'去签名': 'Go sign',
		'确认签名': 'Confirm signature',
		'在此签名': 'Sign here',
		"返回活动": "Back to activity",
		"更多": "More",
		"您可以通过以下方式联系我们": "You can contact us via the following methods",
		"签到信息": "Check in information",
		"签到时间": 'Check in time',
		"预提问": "Collect questions",
		"为充分尊重投资者、提升公司与投资者之间的交流效率，敬请广大投资者在会议开始前提交您所关注的问题，便于公司针对投资者普遍关注的问题进行集中回答": "Investors are requested to submit your concerns before the meeting, so that the company can give a centralized answer.",

		'今天': 'today',
		'选择预约开始时间': 'Select the start time of the appointment',

		"存在必填项未填写，请填写后再进行提交": "Please complete all required fields.",
		"未上传名片，请上传后再进行提交": "Business card not uploaded, please upload it before submitting.",
		"未上传名片/有效证件，请上传后再进行提交": "Business card is required.",
		"姓名未填写，请填写后再进行提交": "Name is not filled in, please fill it in before submitting.",
		"公司未填写，请填写后再进行提交": "Company has not filled in, please fill in before submitting.",
		"职位未填写，请填写后再进行提交": "Position is not filled in, please fill it in before submitting.",
		"请先签字确认您已阅读并同意承诺书": "Please sign first to confirm that you have read and agreed to the letter of commitment.",
		"请先勾选确认您已阅读并同意承诺书": "Please check to confirm that you have read and agreed to the letter of commitment.",
		"我已阅读并同意签署承诺书": "I have read and agreed to sign the commitment letter",
		"同意": "Agree",
		"报名成功，待审核": "Registration succeeded, pending review",
		"审核不通过": "Application failed",
		"审核结果将以短信的形式通知,请留意": "The audit results will be notified by SMS, please pay attention",
		"登记失败，同一邮箱每日每场会最多登记3次": "Registration failed: Each email is limited to 3 sign-ups per event per day.",
		"报名审核成功后，您将收到关于加入会议的信息确认电子邮件，可通过邮件快速入会": "Once your registration is approved, you'll receive a confirmation email with meeting access details for quick entry.",
		"发送参会确认电子邮件，请注意查收": "A confirmation email has been sent to {email}. Please check your inbox.",

		"您可在报名通过后点击会议链接参会或查看其他参会方式": "After the registration is passed, you can click on the meeting link to attend or view other ways to attend",
		"请输入其他选项内容（必填）": "Enter further details.(required)",
		"上传失败，文件大小不能超过500M": "Upload failed. The file size cannot exceed 500M.",
		"上传失败，最多上传5个文件": "Upload failed, supports up to 5 files.",
		"上传失败，请上传word、excel、pdf文件": "Upload failed, Please upload word, excel and pdf files.",
		"新增随行人员": "Add Attendee",
		"名片识别新增": "Identify business cards",
		"新增历史人员": "Historical attendees",
		"手动填写新增": "Fil in manually",
		"请添加报名人员": "Please add registration personnel",
		"所属机构": "Company",
		"职位": "Title",
		"联系方式": "Phone",
		"电子邮箱": "Email",
		"确定要删除该随行人员吗？": "You sure you want to delete this attendee?",
		"姓名和手机号不能为空": "Name and phone cannot be empty.",
		"所属机构不能为空": "Company cannot be empty.",
		"职位不能为空": "Position cannot be empty.",
		"邮件不能为空": "Email cannot be empty.",
		"参会者和随行人员之中存在手机号重复": "Participants and adders are duplicate.",
		"没有更多了": "There is no more",
		"正在识别": "Scanning",
		"请输入姓名": "Please enter your full name.",
		"请输入机构": "Please enter your company.",
		"请输入职位": "Please enter your title.",
		"请输入联系电话": "Please enter your phone number.",
		"请输入邮箱": "Please enter your email.",
		"删除人员": "Delete",
		"代报名成功": 'Success',
		// 沟通日程
		"请输入调研事由或您希望交流的内容": 'What do you want to communicate?',
		"活动时长": "Duration",
		"调研时间": "Time",
		"调研地址": "Address",
		"请选择调研地址": "Please select your address",
		"调研人员": "Information",
		"分钟": "Min",
		"请输入联系方式": "Please enter your phone number.",
		"请输入电子邮箱": "Please enter your email.",
		"请确保名片信息准确无误，上传后将智能识别信息并填充": "Information will be automatically filled in after uploading your business card/Valid ID.",
		"邀约卡片失效": "Invitation card expired",
		"会议ID": "MeetingID",
		"长按图片保存至相册": "Long press to save",
		"如长按图片无法保存可复制链接到浏览器打开页面操作": "If long press does not work, copy the link to the browser to open the page.",
		"选填": "Optional",

		"重发": 'Resend',
		"已向": 'A confirmation email has been sent to',
		"发送确认电子邮件，请注意查收": "Please check your inbox",
		"未收到电子邮件?点击此处": "Didn't receive the email? Click here to resend.",
		"会议正在进行": "The meeting is in progress",
		"距离会议开始": "The meeting will start in",
		"本次路演为机构通路演，您还未通过机构用户认证": "The meeting requires institutional authentication",
		"机构通认证未通过": "Institutional authentication failed",
		"机构通认证通过": "Institutional authentication successful",
		"本次路演为专场路演，请按主办方要求获取权限": "Access required. Follow organizer's instructions",
		"添加日历": "Add Calendar",
		"报名审核已通过，请至会议地点进行参会": 'Please proceed to the meeting location to attend.',
		"报名审核已通过，请准时参会": 'Please attend the meeting on time.',
		"名字": "First Name",
		"姓氏": "Last Name",
		"上传中": 'Uploading',
		"上传失败，请上传 word、excel、pdf 文件": "Upload failed, please upload Word, Excel, PDF files",
		"上传失败，文件大小不能超过200M": "Upload failed. The file size cannot exceed 200M.",
		"提问成功": "Question submitted successfully",
		"加入会议": "Join Meeting",
		"该场会议的报名人数已达上限": "The registration for this meeting is now full.",
		"报名通过": "Registration approved",
		"本地日历": "calendar",
		"本场路演需报名审核通过才能参会": "Registration required",
		"名字未填写，请填写后再进行提交": "First Name not filled in, please fill in before submitting",
		"姓氏未填写，请填写后再进行提交": "Last Name not filled in, please fill in before submitting",
		"请输入真实姓氏": "Please enter your real Last Name",
		"请输入真实名字": "Please enter your real First Name",
		'所属部门': 'Department',
		"请输入所属部门": "Please enter your department",
		"添加至": "Add to",
		"登记成功": "Registered",
		"进门提供技术支持": 'Powered by Comein',
		"*上传名片后将自动填充个人信息": 'Autofill info from business card.',
		"请输入正确的邮箱": "Enter a valid email",
		"请添加签名": "Add your signature",
		"请阅读并同意承诺书": "I have read and agree to the terms.",
		"这是必填项": "Required field",
		"请上传名片/有效证件": "Business card is required.",
		"预提问时间已截止，您可参会进行提问": "The pre-submission period for questions has ended. You can ask questions during the meeting.",
		"查看会议": "View the meeting",

		tips: {
			// 免责声明
			"disclaimerHuaTai": "Disclaimer: Some information and data are sourced from third parties, and the platform cannot verify the authenticity, accuracy, completeness, and originality of the information. Huatai Securities is reproduced for investors' reference and does not represent the views of Huatai Securities. It does not constitute any investment advice. You are responsible for any losses caused by relying on or using third-party information. Market risks, investment needs to be cautious.",
			"disclaimerMember": "This membership service is provided by 'Shenzhen Huaixin Enterprise Investment Consulting Co'. Without the written authorization of Huaixin Investment, no institution or individual may copy or quote the content and views of the conference in any form, including the production of mirror images and links, or the dissemination of audio, video, images, text and other content, Huaixin Investment reserves all legal rights in this regard. The views, remarks, data and other information quoted or broadcasted at the conference are for reference only and are not intended as a basis for investment.",
			"disclaimerNotMember": "Without the written permission of the financial into the door, any institutions and individuals may not copy in any form, citing the content and views of the meeting, including not to create a mirror and point to the link, not to disseminate audio, video, pictures, text and other content, into the financial into the door to retain all legal rights in this regard. All participants of the meeting shall not disclose insider information and important information that is not publicly available, the views, remarks, data and other information quoted or broadcasted at the meeting are for reference only and not as a basis for investment, the market is risky, investment requires caution.",
		},
		submitTipText: {
			// 未登录
			"login": "Join  after <span>sign in</span>",
			// 先报名
			"apply": "<span>Registration</span> Required",
			"applyRecord": "Watch after <span>submit enrollment</span>",
			// 先认证
			"certification": "Join after <span>institutional certification</span>",
			"certificationRecord": "Watch after <span>institutional certification</span>",
			// 白名单
			"whiteList": "The meeting just open to <span>whitelist users</span>",
			"whiteListRecord": "The meeting just open to <span>whitelist users</span>",
			// 购买专栏
			"buyColumn": "Watch after <span>Purchase column</span>",
			// App
			"app": "Please <span>Open Comein Finance APP</span> to watch according to Wechat Mini Program",
			// 买会员
			"buyMember": "Watch after <span>Purchase membership</span>",
			// 买课程
			"buyCourse": "Watch after <span>Purchase course</span>",

		},
		collect: {
			title: "To fully respect investors and enhance communication efficiency between the company and investors, we kindly request that all investors submit questions of their concerns prior to the meeting, This will enable the company to provide centralized answers to issues that are commonly of interest to investors.", // 无需高亮
		},
		'活动日期': 'Date',
		'活动时间': 'Time',
		'亲爱的投资者': 'Dear Investors',
		'感谢您的关注与支持!': 'Thank you for your attention and support!',
		'期待您的莅临': 'looks forward to your visit',
		'机构': 'Company',
		'审批通过': 'Approved',
		'邀请函是您的参会凭证，请长按将邀请函保存至相册': 'Please press  and hold  ticket to save the to the album',
		'境内拨入': 'For Mainland China',
		'境外/海外拨入': 'For Outside Mainland China',
	},
	'zh-cn': {
		...enterpriseModule['zh-cn'],

		tips: {
			"disclaimerHuaTai": "【免责声明】部分资讯信息、数据资料来源于第三方，平台无法核实信息的真实性、准确性、完整性及原创性等。涨乐财富通转载供投资者参考，并不代表华泰证券观点，不构成任何投资建议，您自行承担因信赖或使用第三方信息而导致的任何损失。市场有风险，投资需谨慎。",
			"disclaimerMember": "本会员服务由“深圳怀新企业投资顾问股份有限公司”提供。未经怀新投资书面授权许可，任何机构和个人不得以任何形式复制、引用会议的内容与观点，包括不得制作镜像及指向链接，不得传播音频、视频、图片、文字等内容，怀新投资就此保留一切法律权利。会议引述或播放展示的观点、言论、数据以及其他信息仅作参考，不做投资依据，市场有风险，投资需谨慎。",
			"disclaimerNotMember": "未经进门书面授权许可，任何机构和个人不得以任何形式复制、引用会议的内容与观点，包括不得制作镜像及指向链接，不得传播音频、视频、图片、文字等内容，进门就此保留一切法律权利。会议引述或播放展示的观点、言论、数据以及其他信息仅作参考，不做投资依据，市场有风险，投资需谨慎。",
		},
		submitTipText: {
			"login": "请先<span>登录</span>后参与本场会议",
			// 先报名
			"apply": "本场路演需<span>报名</span>审核通过才能参会",
			"applyRecord": "本场路演需<span>报名</span>审核通过才能观看",
			// 先认证
			"certification": "本场路演需完成<span>机构投资者认证</span>才能参会",
			"certificationRecord": "本场路演需完成<span>机构投资者认证</span>才能观看",
			// 白名单
			"whiteList": "本场路演仅<span>白名单</span>用户才能参会",
			"whiteListRecord": "本场路演仅<span>白名单</span>用户才能观看",
			// 购买专栏
			"buyColumn": "本场路演需购买<span>专栏</span>后才能观看",
			// App
			"app": "应小程序要求，该路演请前往<span>往进门APP</span>观看",
			// 买会员
			"buyMember": "本场路演需购买<span>会员</span>后才能观看",
			// 购买课程
			"buyCourse": "本场路演需购买<span>课程</span>后才能观看",
		},
		collect: {
			title: "为充分尊重投资者、提升公司与投资者之间的交流效率，敬请广大投资者在会议开始前提交您所关注的问题，便于公司针对投资者<span>普遍关注的问题</span>进行集中回答。",
		},

		"发送参会确认电子邮件，请注意查收": "已向 {email} 发送参会确认电子邮件，请注意查收",

	},
	'zh-hk': {
		...enterpriseModule['zh-hk'],
		...lang_hk
	}
}
